import _get from 'lodash/get';
import EnvConfig from './EnvConfig';

import { currentMode } from 'core/util/Mode';
import StartupException from "../exception/StartupException";

const getDev: any = () => (
	require('../../../../app.config.dev.json')
);

const getProd: any = () => (
	require('../../../../app.config.prod.json')
);

const configDev: any = getDev();
const configProd: any = getProd();


export default class ConfigUtil {

	public static getConfig(): object {
		return currentMode.isDev() ? configDev : configProd;
	}

	public static get(property): string | object {
		const config = ConfigUtil.getConfig();
		return _get(config, property); // Using lodash get to support nested objects in property string
	}

	/* public static get<T>(property: string, defaultValue: T) {
		const ret = ConfigUtil.get(property);

		if(typeof ret === "undefined") {
			return defaultValue;
		}

		return ret;
	} */

	public static getString(property, defaultValue?: string): string {
		const p = ConfigUtil.get(property)

		if (typeof p !== "string") {
			return defaultValue;
		}

		return p;
	}

	public static getEnvName() {
		if(typeof process.env.ENV_NAME === "string") {
			return process.env.ENV_NAME;
		}

		return ConfigUtil.getString("defaultEnv");
	}

	public  static getEnvConfig(): EnvConfig {
		const currentEnv = ConfigUtil.getEnvName();

		if(typeof currentEnv !== "string") {
			// there is no enviornment set. log it then kick back to the gateway.
			throw new StartupException("No enviornment specified");
		}

		const config = ConfigUtil.getConfig();

		// get the block from config
		const envConfig =  config["envs"][currentEnv];

		return EnvConfig.fromObject(envConfig);
	}

	public static getVersion() {
		return "4.2";
	}
}

export const getConfig = ConfigUtil.getConfig;
export const get = ConfigUtil.get;
export const getString = ConfigUtil.getString;
export const getVersion = ConfigUtil.getVersion;



// WEBPACK FOOTER //
// ./src/core/util/config/ConfigUtil.ts